import { MarketingNavbar } from './MarketingNavbar';

export function MarketingNavbarContainer() {
  return <MarketingNavbar />;
}
